module.exports = __webpack_public_path__ + "img/signup-grp1.cea0cf6d.png";